import { actionTypes } from '../actions/data';

// DEFAULT STATE
export const initData = {
  latest: {"lastUpdated":null,"enavBidPrice":null,"enavAskPrice":null},
  history: [],
};

// WRITES
const data = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SET_LATEST_DATA:
      return Object.assign({}, state, {
        latest: action.value,
      });
    case actionTypes.SET_HISTORY_DATA:
      return Object.assign({}, state, {
        history: action.value,
      });
    default:
      return state;
  }
};

// READS
export const getLatestData = (state) => state.data.latest;
export const getHistoryData = (state) => state.data.history;

export default data;



// WEBPACK FOOTER //
// ./src/reducers/data.js